export const LED_SESSION_KEY = 'LED_SESSION';
